(() => {
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const initCollection = () => {
    const cards = [...document.querySelectorAll('.template-collection .product-grid .grid__item')];
    if (!cards.length) return;
    cards.forEach((card, index) => {
      card.style.transitionDelay = `${Math.min(index * 90, 450)}ms`;
      const wrapper = card.querySelector('.card-wrapper');
      if (wrapper) wrapper.style.setProperty('--gb-card-tilt', `${index % 2 ? 1.1 : -1.1}deg`);
    });
    if (reduceMotion) {
      cards.forEach((card) => card.classList.add('gb-in'));
      return;
    }
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('gb-in');
        observer.unobserve(entry.target);
      }
    }), { threshold: .12, rootMargin: '0px 0px -4% 0px' });
    cards.forEach((card) => observer.observe(card));
  };
  document.addEventListener('DOMContentLoaded', initCollection);
  document.addEventListener('shopify:section:load', initCollection);
})();
